import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const sidebarRef = useRef(null);

  const services = [
    { name: 'Europe Transport Services', path: '/europeanservices' },
    { name: 'Airport Services', path: '/airportservices' },
    { name: 'Business Same Day', path: '/businesssamedayservices' },
    { name: 'Bespoke Solutions', path: '/bespoke' },
    { name: 'Christmas Delivery', path: '/christmas' },
    { name: 'Cremated Remains', path: '/cremated' },
    { name: 'Domestic Same Day', path: '/domesticsameday' },
    { name: 'Ebay Pickup & Drop Off', path: '/ebaypickupdropoff' },
    { name: 'Education Courier', path: '/educationcourier' },
    { name: 'Emergency Courier', path: '/emergencycourier' },
    { name: 'Forgotten Something?', path: '/forgottensomething' },
    { name: 'Industrial Estates', path: '/industrialestates' },
    { name: 'Medical Deliveries', path: '/medicaldeliveries' },
    { name: 'Overnight Delivery', path: '/overnightdelivery' },
    { name: 'Student Removals', path: '/studentremovals' },
    { name: 'Two Man Delivery', path: '/twomandelivery' },
    { name: 'Urgent Documents', path: '/urgentdocuments' },
    { name: 'Weekend Couriers', path: '/weekendcouriers' },
  ];

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isSidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <header>
      <nav className="flex items-center justify-between px-4  py-3 md:py-4 lg:px-20">
        {/* Logo */}
        <div className=' pt-5 flex justify-center'>
          <Link to="/">
            <img
              className="w-32 h-12 lg:w-44 lg:h-12"
              src="images/logonew.png"
              alt="Logo"
            />
          </Link>
        </div>

       {/* Desktop Navigation */}
       <div className="hidden xl:flex items-center justify-end gap-10 w-full whitespace-nowrap">
  <div className="flex items-center gap-10 2xl:gap-16">
    {/* Navigation Links */}
    <Link to="/aboutus" className="text-lg font-semibold hover:text-orange-600 hover:underline">
      About Us
    </Link>
    <Link to="/airfreightservice" className="text-lg font-semibold hover:text-orange-600 hover:underline">
      Air Freight
    </Link>
    <Link to="/shipping" className="text-lg font-semibold hover:text-orange-600 hover:underline">
      Shipping
    </Link>
    <Link to="/relocation" className="text-lg font-semibold hover:text-orange-600 hover:underline">
      Relocation
    </Link>
    {/* Our Services Dropdown */}
    <div
      className="relative"
      onMouseEnter={() => setIsServicesOpen(true)}
      onMouseLeave={() => setIsServicesOpen(false)}
    >
      <button className="text-lg font-semibold hover:text-orange-600 hover:underline">
        Our Services
      </button>
      {isServicesOpen && (
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 bg-white shadow-lg rounded-md py-2 px-4 w-64 z-50">
          <ul>
            {services.map((service, index) => (
              <li key={index}>
                <Link to={service.path} className="block px-4 py-2 text-gray-800 hover:text-orange-600">
                  {service.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>

    <Link to="/fleet" className="text-lg font-semibold hover:text-orange-600 hover:underline">
      The Fleet
    </Link>

    {/* Contact Us Button - Placed at Right */}
    <Link to="/contactus" className="text-lg font-semibold bg-slate-800 text-white py-2 px-4">
      Contact Us
    </Link>
  </div>
</div>



        {/* Mobile Sidebar Toggle */}
        <div className="xl:hidden ">
        <button onClick={toggleSidebar} className="text-3xl text-black">
          <FontAwesomeIcon icon={faBars} />
        </button></div>

        {/* Sidebar */}
        <div
  ref={sidebarRef}
  className={`fixed top-0 right-0 pb-12 bg-white w-3/5 text-center md:w-1/3 shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
    isSidebarOpen ? 'translate-x-0' : 'translate-x-full'
  } h-[80vh] max-h-[60vh] overflow-y-auto`}
>
  <button
    className="absolute top-4 right-4 text-2xl"
    onClick={toggleSidebar}
  >
    <i className="fas fa-times"></i>
  </button>

  <ul className="mt-16 space-y-6 px-6 overflow-y-auto max-h-full">
  <li>
    <Link
      to="/aboutus"
      className="block text-lg font-semibold"
      onClick={() => setIsSidebarOpen(false)}
    >
      About Us
    </Link>
  </li>
  
  {/* Our Services Dropdown */}
  <li>
    <button
      onClick={() => setIsServicesOpen(!isServicesOpen)}
      className="w-full text-lg font-semibold text-center items-center"
    >
      Our Services
      <i
        className={`fas ${isServicesOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}
      ></i>
    </button>
    {isServicesOpen && (
      <ul className="mt-2 pl-4 space-y-2">
        {services.map((service, index) => (
          <li key={index} className="py-2">
            <Link
              to={service.path}
              className="block text-base text-gray-600 hover:text-orange-600"
              onClick={() => {
                setIsSidebarOpen(false); // Close sidebar
                setIsServicesOpen(false); // Close services dropdown
              }}
            >
              {service.name}
            </Link>
          </li>
        ))}
      </ul>
    )}
  </li>

  <li>
    <Link
      to="/airfreightservice"
      className="block text-lg font-semibold"
      onClick={() => setIsSidebarOpen(false)}
    >
      Airfreight
    </Link>
  </li>
  <li>
    <Link
      to="/shipping"
      className="block text-lg font-semibold"
      onClick={() => setIsSidebarOpen(false)}
    >
      Shipping
    </Link>
  </li>
  <li>
    <Link
      to="/relocation"
      className="block text-lg font-semibold"
      onClick={() => setIsSidebarOpen(false)}
    >
      Relocation
    </Link>
  </li>
  <li>
    <Link
      to="/fleet"
      className="block text-lg font-semibold"
      onClick={() => setIsSidebarOpen(false)}
    >
      The Fleet
    </Link>
  </li>
  <li>
    <Link
      to="/contactus"
      className="block text-lg font-semibold"
      onClick={() => setIsSidebarOpen(false)}
    >
      Contact Us
    </Link>
  </li>
</ul>

</div>

      </nav>
    </header>
  );
}

export default Header;


// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBars } from "@fortawesome/free-solid-svg-icons";

// function Header() {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
//   const sidebarRef = useRef(null);

//   const services = [
//     { name: 'Europe Transport Services', path: '/europeanservices' },
//     { name: 'Airport Services', path: '/airportservices' },
//     { name: 'Business Same Day', path: '/businesssamedayservices' },
//     { name: 'Bespoke Solutions', path: '/bespoke' },
//     { name: 'Christmas Delivery', path: '/christmas' },
//     { name: 'Cremated Remains', path: '/cremated' },
//     { name: 'Domestic Same Day', path: '/domesticsameday' },
//     { name: 'Ebay Pickup & Drop Off', path: '/ebaypickupdropoff' },
//     { name: 'Education Courier', path: '/educationcourier' },
//     { name: 'Emergency Courier', path: '/emergencycourier' },
//     { name: 'Forgotten Something?', path: '/forgottensomething' },
//     { name: 'Industrial Estates', path: '/industrialestates' },
//     { name: 'Medical Deliveries', path: '/medicaldeliveries' },
//     { name: 'Overnight Delivery', path: '/overnightdelivery' },
//     { name: 'Student Removals', path: '/studentremovals' },
//     { name: 'Two Man Delivery', path: '/twomandelivery' },
//     { name: 'Urgent Documents', path: '/urgentdocuments' },
//     { name: 'Weekend Couriers', path: '/weekendcouriers' },
//   ];

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         isSidebarOpen &&
//         sidebarRef.current &&
//         !sidebarRef.current.contains(event.target)
//       ) {
//         setIsSidebarOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isSidebarOpen]);

//   return (
//     <header>
//       <nav className="flex items-center justify-between px-4 py-4 lg:px-20">
//         {/* Logo */}
//         <div>
//           <Link to="/">
//             <img
//               className="w-36 h-12 lg:w-44 lg:h-14"
//               src="images/sslogo.png"
//               alt="Logo"
//             />
//           </Link>
//         </div>

//        {/* Desktop Navigation */}
//        <div className="hidden xl:flex items-center justify-end gap-10 w-full whitespace-nowrap">
//   <div className="flex items-center gap-20">
//     {/* Navigation Links */}
//     <Link to="/aboutus" className="text-lg font-semibold hover:text-orange-600 hover:underline">
//       About Us
//     </Link>
//     <Link to="/airfreightservice" className="text-lg font-semibold hover:text-orange-600 hover:underline">
//       Air Freight
//     </Link>
//     <Link to="/shipping" className="text-lg font-semibold hover:text-orange-600 hover:underline">
//       Shipping
//     </Link>

//     {/* Our Services Dropdown */}
//     <div
//       className="relative"
//       onMouseEnter={() => setIsServicesOpen(true)}
//       onMouseLeave={() => setIsServicesOpen(false)}
//     >
//       <button className="text-lg font-semibold hover:text-orange-600 hover:underline">
//         Our Services
//       </button>
//       {isServicesOpen && (
//         <div className="absolute top-full left-1/2 transform -translate-x-1/2 bg-white shadow-lg rounded-md py-2 px-4 w-64 z-50">
//           <ul>
//             {services.map((service, index) => (
//               <li key={index}>
//                 <Link to={service.path} className="block px-4 py-2 text-gray-800 hover:text-orange-600">
//                   {service.name}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </div>

//     <Link to="/fleet" className="text-lg font-semibold hover:text-orange-600 hover:underline">
//       The Fleet
//     </Link>

//     {/* Contact Us Button - Placed at Right */}
//     <Link to="/contactus" className="text-lg font-semibold bg-slate-800 text-white py-2 px-4">
//       Contact Us
//     </Link>
//   </div>
// </div>



//         {/* Mobile Sidebar Toggle */}
//         <div className="xl:hidden ">
//         <button onClick={toggleSidebar} className="text-3xl text-black">
//           <FontAwesomeIcon icon={faBars} />
//         </button></div>

//         {/* Sidebar */}
//         <div
//           ref={sidebarRef}
//           className={`fixed top-0 right-0 pb-12  bg-white w-3/5 text-center md:w-1/3 shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
//             isSidebarOpen ? 'translate-x-0' : 'translate-x-full'
//           }`}
//         >
//           <button
//             className="absolute top-4 right-4 text-2xl"
//             onClick={toggleSidebar}
//           >
//             <i className="fas fa-times"></i>
//           </button>
//           <ul className="mt-16 space-y-6 px-6">
//             <li>
//               <button
//                 onClick={() => setIsServicesOpen(!isServicesOpen)}
//                 className="flex items-center justify-between w-full text-lg font-semibold"
//               >
//                 Our Services
//                 <i
//                   className={`ml-2 fas ${
//                     isServicesOpen ? 'fa-chevron-up' : 'fa-chevron-down'
//                   }`}
//                 ></i>
//               </button>
//               {isServicesOpen && (
//                 <ul className="mt-2 pl-4 space-y-2">
//                   {services.map((service, index) => (
//                     <li key={index}>
//                       <Link
//                         to={service.path}
//                         className="block text-base text-gray-600 hover:text-orange-600"
//                       >
//                         {service.name}
//                       </Link>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>
//     <li>
//               <Link to="/airfreightservice" className="block text-lg font-semibold">
//               Airfreight
//               </Link>
//             </li>
//             <li>
//               <Link to="/shipping" className="block text-lg font-semibold">
//               Shipping
//               </Link>
//             </li>
            
//             <li>
//               <Link to="/fleet" className="block text-lg font-semibold">
//                 The Fleet
//               </Link>
//             </li>
//             <li>
//               <Link to="/aboutus" className="block text-lg font-semibold">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contactus" className="block text-lg font-semibold">
//                 Contact Us
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </nav>
//     </header>
//   );
// }

// export default Header;

